import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import React from 'react';

const ErrorToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#FBE7E7',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FBE7E7',
    color: '#F1416C',
    minWidth: '100px',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default ErrorToolTip;
